/**
 * @file paddlex 用户信息
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import { Button, Divider, Form, Input, Radio, RadioChangeEvent, Select, Space } from 'antd';
import careerMap from '../../data/careerMap.json';
import teamSizeMap from '../../data/teamSizeMap.json';
import PaddleTextarea from '../../../../../paddlex/pages/user-info/components/paddle-textarea/PaddleTextarea';
// import industryMap from '../../../../../paddlex/pages/user-info/data/industryMap.json';
import { industryItem } from '../../type';
import { FormInstance } from 'antd/es/form';
import { PlusOutlined } from '@ant-design/icons';

interface IUserInfoFormProps {
    userInfoForm: FormInstance;
    // verifyCodeImg: string;
    // getVerifyCode: () => void;
    careerType: number;
    onFormSubmit: (feildValue: any) => void;
    onFormCancel: () => void;
    handleCareerTypeChange: (e: RadioChangeEvent) => void;
    industryInput: string;
    onIndustryInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    industryData: industryItem[];
    addItem: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void;
    selectOpen: boolean;
    setSelectOpen: (open: boolean) => void;
}

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
    }
};

const UserInfoForm: React.FC<IUserInfoFormProps> = props => {
    const {
        userInfoForm,
        // verifyCodeImg,
        // getVerifyCode,
        careerType,
        onFormSubmit,
        onFormCancel,
        handleCareerTypeChange,
        industryInput,
        onIndustryInputChange,
        industryData,
        addItem,
        selectOpen,
        setSelectOpen
    } = props;

    return (
        <Form form={userInfoForm} className="paddle-lab-user-info-form" onFinish={onFormSubmit} {...formItemLayout}>
            <Form.Item
                labelAlign="left"
                label="姓名"
                name="customername"
                rules={[{ required: true, message: '请输入姓名' }]}
            >
                <Input className="paddle-lab-user-info-form-input" size="large" placeholder="请输入姓名" />
            </Form.Item>
            <Form.Item
                labelAlign="left"
                label="联系方式"
                name="mobile"
                rules={[
                    { required: true, message: '请输入手机号' },
                    { pattern: /^1\d{10,10}/, message: '请输入正确的手机号' }
                ]}
            >
                <Input className="paddle-lab-user-info-form-input" size="large" placeholder="方便飞桨团队与您交流" />
            </Form.Item>
            <Form.Item
                labelAlign="left"
                label="您的职业"
                name="cutomerCareerType"
                rules={[{ required: true, message: '请选择职业' }]}
            >
                <Radio.Group onChange={handleCareerTypeChange}>
                    {/* <Space direction="vertical"> */}
                    {careerMap.map(item =>
                        item.value === '其他' ? (
                            <Radio key={item.value} value={item.value} className="paddle-lab-careertype-input-label">
                                其他
                                {careerType === 0 ? (
                                    <Form.Item name="careerTypeInput">
                                        <Input
                                            className="paddle-lab-careertype-input"
                                            style={{ width: 210, marginLeft: 10 }}
                                        />
                                    </Form.Item>
                                ) : null}
                            </Radio>
                        ) : (
                            <Radio key={item.value} value={item.value}>
                                {item.text}
                            </Radio>
                        )
                    )}
                    {/* </Space> */}
                </Radio.Group>
            </Form.Item>
            <Form.Item
                labelAlign="left"
                label="工作单位/高校院所"
                name="customerCompany"
                rules={[{ required: true, message: '请输入所在工作单位/高校院所' }]}
            >
                <Input
                    className="paddle-lab-user-info-form-input"
                    size="large"
                    placeholder="请输入所在工作单位/高校院所"
                />
            </Form.Item>
            <Form.Item
                labelAlign="left"
                label="所属行业"
                name="industry"
                rules={[{ required: true, message: '请选择所属行业' }]}
            >
                <Select
                    className="paddle-lab-user-info-form-select"
                    dropdownClassName="paddle-lab-user-info-form-select-dropdown"
                    size="large"
                    placeholder="请选择所属行业"
                    open={selectOpen}
                    onDropdownVisibleChange={visible => setSelectOpen(visible)}
                    dropdownRender={menu => (
                        <>
                            <Space style={{ padding: '0 8px 4px' }}>
                                <Input
                                    placeholder="请添加您所属行业"
                                    value={industryInput}
                                    onChange={onIndustryInputChange}
                                    style={{ width: 360 }}
                                />
                                <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
                                    自定义行业
                                </Button>
                            </Space>
                            <Divider style={{ margin: '8px 0' }} />
                            {menu}
                        </>
                    )}
                    options={industryData.map(item => ({ label: item.text, value: item.value }))}
                />
            </Form.Item>
            <Form.Item
                labelAlign="left"
                label="团队规模"
                name="teamSizeType"
                rules={[{ required: true, message: '请选择您所在团队规模' }]}
            >
                <Radio.Group>
                    {/* <Space direction="vertical"> */}
                    {teamSizeMap.map(item => (
                        <Radio key={item.value} value={item.value}>
                            {item.text}
                        </Radio>
                    ))}
                    {/* </Space> */}
                </Radio.Group>
            </Form.Item>
            <Form.Item
                labelAlign="left"
                label="应用场景"
                name="scene"
                rules={[{ required: true, message: '请输入深度学习应用场景' }]}
            >
                <PaddleTextarea
                    className="paddle-lab-user-info-form-textarea"
                    maxLength={100}
                    rows={8}
                    placeholder="请输入深度学习应用场景"
                />
            </Form.Item>
            {/* <Form.Item className="verify-code-form-item-wrap" labelAlign="left" label="验证码" required>
                <Form.Item
                    className="verify-code-wrap"
                    name="verifyCode"
                    rules={[{ required: true, message: '请输入验证码' }]}
                >
                    <Input
                        className="paddle-lab-user-info-form-input verify-code-input"
                        size="large"
                        placeholder="请输入验证码"
                    />
                </Form.Item>
                <div className="verify-code-img-wrap" onClick={getVerifyCode}>
                    <img alt="验证码" src={verifyCodeImg} />
                </div>
                <i className="verify-code-img-reload" onClick={getVerifyCode} />
            </Form.Item> */}
            <Form.Item labelAlign="left" wrapperCol={{ sm: { offset: 6, span: 19 }, xs: { offset: 0, span: 24 } }}>
                <Button className="paddle-lab-user-info-form-btn" size="large" type="primary" htmlType="submit">
                    保存
                </Button>
                <Button className="paddle-lab-user-info-form-btn" size="large" onClick={onFormCancel}>
                    取消
                </Button>
            </Form.Item>
        </Form>
    );
};

export default UserInfoForm;
